'use strict';

var addHuman = require('../internal/addHuman'),
    runHumanRules = require('../../common/internal/runHumanRules');

var inflectHumans;

function buildCommonHumans() {

  inflectHumans = runHumanRules;

  addHuman(/_id$/g, '');
}

buildCommonHumans();

module.exports = inflectHumans;